import { render, staticRenderFns } from "./SchemaEntriesEditor.vue?vue&type=template&id=64f6c862&scoped=true"
import script from "./SchemaEntriesEditor.vue?vue&type=script&lang=js"
export * from "./SchemaEntriesEditor.vue?vue&type=script&lang=js"
import style0 from "./SchemaEntriesEditor.vue?vue&type=style&index=0&id=64f6c862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f6c862",
  null
  
)

export default component.exports